export enum VehicleSpeedEnum {
    GREEN = 'GREEN',
    RED = 'RED',
    YELLOW = 'YELLOW',
    GREY = 'GREY'
}

export enum CarCategory {
    PASSENGER_CAR = 'PASSENGER_CAR',
    VAN = 'VAN',
    TRUCK = 'TRUCK',
    MACHINE = 'MACHINE',
    SEMI_TRAILER = 'SEMI_TRAILER'
}

export enum CarActiveStatus {
    ACTIVE = 'ACTIVE',
    TURNED_OFF = 'TURNED_OFF',
    NO_ACTIVITY = 'NO_ACTIVITY'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/VehicleEnumTypes.ts